import { useEffect } from "react";
import httpClient from "../../HTTPService";
import { useState } from "react";
import { ToastContainer, toast } from 'react-toastify';
import React, { useRef } from 'react';
import Loding from "../../Component/Loding/Loding";
import { json, useLocation, useNavigate } from "react-router-dom";
const FormManagement = () => {
    const [chooseFldType, setchooseFldType] = useState('')
    const [choosetype, setchoosetype] = useState(null)
    const [labelvalue, setLabel] = useState()
    const navigate = useNavigate()
    const [chooseName, setchooseName] = useState()
    const [optionValue, setOptions] = useState()
    const [labelList, setLabelList] = useState([])
    const [chooseplaceholder, setChooseplaceholder] = useState("")
    const [chooseRequired, setChooseRequired] = useState(1)
    const [getCategory, setgetCategory] = useState();
    const [getSubCategory, setgetSubCategory] = useState(null)
    const [selectSub, setectSub] = useState();
    const [subCat, setSubcatory] = useState();
    const [dynamicFld, setdynamicFld] = useState([]);
    const [optionList, setoptionList] = useState([]);
    const [lebelnmaedata, setleblenamedata] = useState()
    const [loadingState, setLoadingState] = useState(false)
    const [labelselectedStatic, setLabelselectedStatic] = useState(0)
    const location = useLocation()
    // const [invalid, setinvalid] = useState(false)
    // const [form]
    const queryParams = new URLSearchParams(location.search); // Parse query string
    const id = queryParams.get('id');
    const [checkChostype, setChosetype] = useState(false)
    const labeltype_data = [
        {
            id: 1,
            name: "Full Name",
            icon: 'user',
            value: 'name',
            icon_type: 'Feather'

        },
        {
            id: 3,
            name: "Email Address",
            value: 'email_address',
            icon: 'mail',
            icon_type: 'Feather'

        },
        {
            id: 4,
            name: "Phone",
            icon: 'phone',
            value: 'phone',

            icon_type: 'Feather'

        },

        {
            id: 5,
            name: "Date of Birth",
            icon: 'calender',
            value: 'calender',
            icon_type: 'Feather'

        },

        {
            id: 6,
            name: "Address",
            icon: 'home',
            value: 'address',
            icon_type: 'Feather'

        },
        {
            id: 7,
            name: "Apartment/Suite/Unit",
            icon: 'home',
            value: 'apartment',
            icon_type: 'Feather'

        },
        {
            id: 8,
            name: "City",
            icon: 'city',
            value: 'city',
            icon_type: 'FontAwesome5'

        },

        {
            id: 9,
            name: "PIN Code",
            icon: 'location-pin',
            value: 'pin',
            icon_type: 'Entypo'

        },

        {
            id: 10,
            name: "Company Name",
            icon: 'building-o',
            value: 'company_name',
            icon_type: 'FontAwesome'

        },
        {
            id: 11,
            name: "Job Title",
            icon: 'contacts',
            value: 'job_title',
            icon_type: 'AntDesign'

        },
        {
            id: 12,
            name: "Department",
            icon: 'building-o',
            value: 'department',
            icon_type: 'FontAwesome'

        },
        // {
        //     id: 16,
        //     name: "Comments",
        //     icon: 'message1',
        //     value: 'comments',
        //     icon_type: 'AntDesign'

        // },
        // {
        //     id: 17,
        //     name: "Suggestions",
        //     icon: 'settings-suggest',
        //     value: 'suggestions',
        //     icon_type: 'MaterialIcons'

        // },
        // {
        //     id: 18,
        //     name: "Feedback",
        //     icon: 'feed-discussion',
        //     value: 'feed_back',
        //     icon_type: 'Octicons'

        // },

        // {
        //     id: 20,
        //     name: "Review",
        //     icon: 'staro',
        //     value: 'review',

        //     icon_type: 'AntDesign'

        // },
        {
            id: 13,
            name: "School/University Name",
            icon: 'school',
            value: 'school',

            icon_type: 'FontAwesome5'

        },
        {
            id: 14,
            name: "Degree",
            icon: 'school',
            value: 'degree',
            icon_type: 'FontAwesome5'

        },
        {
            id: 15,
            name: "Major",
            icon: 'school',
            value: 'major',
            icon_type: 'FontAwesome5'

        },
        {
            id: 16,
            name: "Graduation Year",
            icon: 'calendar',
            value: 'graduation_year',

            icon_type: 'AntDesign'

        },
        {
            id: 17,
            name: "Employer Name",
            icon: 'user',
            value: 'employer_name',

            icon_type: 'Feather'

        },
        {
            id: 18,
            name: "Job Title",
            icon: 'user',
            value: 'job_title',

            icon_type: 'Feather'
        },
        {
            id: 19,
            name: "Employment Start Date",
            icon: 'calendar',
            value: 'employment_start_date',

            icon_type: 'AntDesign'

        },
        {
            id: 20,
            name: "Employment End Date",
            icon: 'calendar',
            value: 'employment_end_date',
            icon_type: 'AntDesign'

        },
        // {
        //     id: 28,
        //     name: "Query",
        //     icon: 'calendar',
        //     value: 'query',

        //     icon_type: 'AntDesign'

        // },
        {
            id: 21,
            name: "Description",
            icon: 'calendar',
            value: 'description',

            icon_type: 'AntDesign'

        },
        {
            id: 22,
            name: "Notes",
            icon: 'calendar',
            value: 'notes',

            icon_type: 'AntDesign'

        },
        {
            id: 23,
            name: "Additional Information",
            value: 'additional_information',
            icon: 'calendar',
            icon_type: 'AntDesign'

        },
        {
            id: 24,
            name: "WhatsApp",
            value: 'whatsapp',
            icon: 'whatsapp',
            icon_type: 'FontAwesome'

        },
        {
            id: 25,
            name: "Community",
            value: 'community',
            icon: 'addusergroup',
            icon_type: 'AntDesign'

        },
        {
            id: 26,
            name: "Occupation",
            value: 'occupation',
            icon: 'briefcase',
            icon_type: 'FontAwesome'

        },
        {
            id: 27,
            name: "House No/Street/Road",
            value: 'house_no_street_road',
            icon: 'house-user',
            icon_type: 'FontAwesome5'

        },
        {
            id: 28,
            name: "Area/Local/Sector",
            value: 'area_local_sector',
            icon: 'road',
            icon_type: 'FontAwesome'

        },
        {
            id: 29,
            name: "Village/City/Town",
            value: 'village_city_town',
            icon: 'city',
            icon_type: 'FontAwesome5'

        },
        {
            id: 29,
            name: "Post Office",
            value: 'post_office',
            icon: 'school',
            icon_type: 'FontAwesome5'

        },



    ]

    const [ismultiple, setismultiple] = useState(0)
    const [isrequired, setisrequired] = useState(false)
    useEffect(() => {
        getcatname();
    }, []);

    useEffect(() => {
        getlabelList()
    }, [])
    // Get Option List
    const getlabelList = async () => {
        try {
            const result = await httpClient.post("/admin/all-input-labels", {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            setLabelList(result.data.data)
            // console.log(result.data);
        }
        catch (error) {

        }
    }
    useEffect(() => {
        if (getSubCategory) {
            getSub(getSubCategory);
        }
    }, [getSubCategory])
    // get sub cat
    useEffect(() => {
        // console.log(chooseFldType)
        const _final_data = {
            name: chooseFldType,
            value: chooseFldType,

        }
        if (chooseFldType === 'file' || chooseFldType === 'date' || chooseFldType === 'time') {
            setLabel(chooseFldType)
            console.log(_final_data)
            // setleblenamedata(_final_data)
        }
        // console.log('field type.....')
        setleblenamedata(_final_data)
        // console.log(chooseFldType)
    }, [chooseFldType])
    useEffect(() => {

        if (chooseFldType == 'date') {
            let fil_data = dateOptions?.find(item => {
                if (item.value == labelvalue) {
                    let returnObj = {
                        name: item?.name,
                        value: item?.value,

                    }
                    return returnObj
                } else {
                    return null
                }
            })
            console.log(fil_data, 'date label selected option..???????????//////////////')
            setleblenamedata(fil_data)

            return
        }
        if (labelvalue != 'file' && labelvalue != 'time') {
            let fil_data = labelList?.find(item => {
                if (item.id == labelvalue) {
                    let returnObj = {
                        name: item?.name,
                        value: item?.value,

                    }
                    return returnObj
                } else {
                    return null
                }
            })
            console.log(fil_data, 'seke')
            setleblenamedata(fil_data)
        }
    }, [labelvalue])
    useEffect(() => {
        if (choosetype !== null) {

            let choose_data = optionList?.find(item => item?.id == choosetype)
            const _final_data = {
                name: choose_data?.name,
                value: choose_data?.name,

            }
            setleblenamedata(_final_data)
        }

    }, [choosetype])

    function ondeleteItems(indexs) {
        let _modifiedarray = dynamicFld?.filter((obj, index) => index !== indexs)
        setdynamicFld(_modifiedarray)
    }

    useEffect(() => {
        if (id != undefined) {
            getformDetails()
        }
    }, [id])

    const getformDetails = async (category_id) => {
        // setLoadingState(true)
        try {
            const result = await httpClient.post("/admin/form/view", JSON.stringify({ id: id }), {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            }).then((res) => {
                setSubcatory(res.data.data?.sub_category_id)
                setgetSubCategory(res.data.data?.category_id)
                let _actualdata = JSON.parse(res.data.data?.form_data)
                console.log(_actualdata, 'hh')
                let _data = _actualdata?.map((item) => {
                    let data = {
                        type: item.type,
                        select_box_type: item.type,
                        label: item.label,
                        name: item.name,
                        place_holder: item.place_holder,
                        is_required: parseInt(item?.is_required),
                        value: item?.value,
                        option: item?.option != undefined ? item?.option : 0,
                        ismultiple: item?.ismultiple != undefined ? item?.ismultiple : 0,

                    }
                    return data
                })
                setdynamicFld(_data)
            })

            // setLoadingState(false)

        }

        catch (error) {
            toast.error(error.message)
        }
    }

    const getSub = async (category_id) => {
        // setLoadingState(true)
        try {
            const result = await httpClient.post("/admin/all-sub-categories-list", { category_id }, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            setectSub(result.data.data)
            // setLoadingState(false)

        }

        catch (error) {
            toast.error(error.message)
        }
    }
    // add From 
    const addFld = async (event) => {
        console.log(
            {
                lebelnmaedata

            },
            'data...'
        )
        if (labelvalue === null || chooseFldType === null || lebelnmaedata?.name === null) {
            setisrequired(true)
            return
        }
        event.preventDefault();

        setdynamicFld(prevOptionData => {
            if (prevOptionData.length > 0) {
                return [...prevOptionData, {
                    type: chooseFldType,
                    select_box_type: choosetype,
                    label: lebelnmaedata?.name,
                    name: lebelnmaedata?.value,
                    place_holder: chooseplaceholder?.charAt(0).toUpperCase() + chooseplaceholder?.slice(1),
                    is_required: Number(chooseRequired),
                    option: choosetype,
                    value: "",
                    ismultiple: ismultiple

                }];
            } else {
                return [{
                    type: chooseFldType,
                    select_box_type: choosetype,
                    label: lebelnmaedata?.name?.charAt(0).toUpperCase() + lebelnmaedata?.name?.slice(1),
                    name: lebelnmaedata?.value?.charAt(0).toLowerCase() + lebelnmaedata?.value?.slice(1),
                    place_holder: chooseplaceholder?.charAt(0).toUpperCase() + chooseplaceholder?.slice(1),
                    is_required: Number(chooseRequired), option: choosetype, value: "",
                    option: choosetype,
                    value: "",
                    ismultiple: ismultiple

                }];
            }
        });
        setLabel(0)
        setchooseFldType('')
        setchoosetype(null)
        setleblenamedata(null)
        setChooseplaceholder('')
        // setChooseRequired('')
        document.getElementById('resetForm').reset()
    }
    const FrmCreation = async () => {
        console.log(dynamicFld, 'form cration')

        let body = {
            category_id: getSubCategory,
            sub_category_id: subCat,
            id: id,
            form_data: dynamicFld
        }
        console.log(body, 'paylaod  body>>>>>>>>>>>>>>>>>>>>>>>>>>')
        if (id != undefined) {
            let body = {
                category_id: getSubCategory,
                sub_category_id: subCat,
                id: id,
                form_data: dynamicFld
            }

            console.log(body, 'update data')
            try {
                const result = await httpClient.post("/admin/form/update", JSON.stringify(body), {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                })
                if (result.data.status) {
                    // localStorage.removeItem('editSubData')
                    // document.getElementById('addForm').reset();
                    toast.success(result.data.message);
                    setTimeout(() => {
                        navigate('/formlist')
                    }, 1000)

                }


                if (result.data.status == false) {
                    toast.error(result.data.message)
                }


            }
            catch (error) {
                toast.error(error.message)
            }

        } else {

            try {
                const result = await httpClient.post("/admin/form/create", { category_id: getSubCategory, sub_category_id: subCat, form_data: dynamicFld }, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                }).then((res) => {
                    if (res.status === 200) {
                        console.log(res.data, 'RESPONSE MDATATA..')
                        toast.success("Form Creation Successfully!")
                        navigate('/formlist')
                    } else {
                        // if (result.data.status == false) {
                        toast.error(result.data.message)
                        // }
                    }
                })

            }

            catch (error) {
                toast.error(error.message)
            }
        }



    }
    const setfldType = async (val) => {
        // setLoadingState(true)
        setchooseFldType(val)
        if (val == "select") {
            try {
                const result = await httpClient.post("/admin/option-masters-list", { ofset: 1, limit: 500 }, {
                    headers: {
                        "Content-Type": "application/json",
                        "Accept": "application/json",
                        'Authorization': `Bearer ${localStorage.getItem('token')}`
                    }
                })

                setoptionList(result.data.data)
                // setLoadingState(false)

            }
            catch (error) {

            }
        } else {
            setoptionList([])
        }
    }
    const back = () => {
        navigate('/formlist')

    }


    const getcatname = async () => {
        try {
            const result = await httpClient.post("/admin/all-categories-list", {}, {
                headers: {
                    "Content-Type": "application/json",
                    "Accept": "application/json",
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                }
            })
            setgetCategory(result.data.data);

        }
        catch (error) {

        }
    }

    const dateOptions = [
        { name: "Date of Birth", value: "date_of_birth" },
        { name: "Date of Registration", value: "date_of_registration" },
        { name: "Date of Issue", value: "date_of_issue" },
        { name: "Date of Expiry", value: "date_of_expiry" },
        { name: "Date of Purchase", value: "date_of_purchase" },
        { name: "Date of Sale", value: "date_of_sale" },
        { name: "Date of Appointment", value: "date_of_appointment" },
        { name: "Date of Joining", value: "date_of_joining" },
        { name: "Date of Termination", value: "date_of_termination" },
        { name: "Date of Admission", value: "date_of_admission" },
        { name: "Date of Graduation", value: "date_of_graduation" },
        { name: "Date of Retirement", value: "date_of_retirement" },
        { name: "Date of Certification", value: "date_of_certification" },
        { name: "Date of Activation", value: "date_of_activation" },
        { name: "Date of Deactivation", value: "date_of_deactivation" },
        { name: "Date of Completion", value: "date_of_completion" },
        { name: "Date of Inspection", value: "date_of_inspection" },
        { name: "Date of Payment", value: "date_of_payment" },
        { name: "Date of Delivery", value: "date_of_delivery" },
        { name: "Date of Submission", value: "date_of_submission" },
        { name: "Date of Approval", value: "date_of_approval" },
        { name: "Date of Dispatch", value: "date_of_dispatch" },
        { name: "Date of Renewal", value: "date_of_renewal" },
        { name: "Date of Departure", value: "date_of_departure" },
        { name: "Date of Arrival", value: "date_of_arrival" },
        { name: "Date of Enrollment", value: "date_of_enrollment" },
        { name: "Date of Hire", value: "date_of_hire" },
        { name: "Date of Confirmation", value: "date_of_confirmation" },
        { name: "Date of Transfer", value: "date_of_transfer" },
        { name: "Date of Filing", value: "date_of_filing" },
        { name: "Date of Rejection", value: "date_of_rejection" },
        { name: "Date of Release", value: "date_of_release" },
        { name: "Date of Inception", value: "date_of_inception" },
        { name: "Date of Manufacture", value: "date_of_manufacture" },
        { name: "Date of Maintenance", value: "date_of_maintenance" },
        { name: "Date of Production", value: "date_of_production" },
        { name: "Date of Shipment", value: "date_of_shipment" },
        { name: "Date of Export", value: "date_of_export" },
        { name: "Date of Import", value: "date_of_import" },
        { name: "Date of Allocation", value: "date_of_allocation" },
        { name: "Date of Deployment", value: "date_of_deployment" },
        { name: "Date of Backup", value: "date_of_backup" },
        { name: "Date of Restoration", value: "date_of_restoration" },
        { name: "Date of Cancellation", value: "date_of_cancellation" },
        { name: "Date of Claim", value: "date_of_claim" },
        { name: "Date of Incident", value: "date_of_incident" },
        { name: "Date of Report", value: "date_of_report" },
        { name: "Date of Assignment", value: "date_of_assignment" },
        { name: "Date of Commencement", value: "date_of_commencement" },
        { name: "Date of Conclusion", value: "date_of_conclusion" },
        { name: "Date of Receipt", value: "date_of_receipt" },
        { name: "Date of Authorization", value: "date_of_authorization" },
        { name: "Date of Investment", value: "date_of_investment" },
        { name: "Date of Settlement", value: "date_of_settlement" },
        { name: "Date of Coverage", value: "date_of_coverage" },
        { name: "Date of Effective", value: "date_of_effective" },
        { name: "Date of Maturity", value: "date_of_maturity" },
        { name: "Date of Transaction", value: "date_of_transaction" },
        { name: "Date of Setup", value: "date_of_setup" },
        { name: "Date of Establishment", value: "date_of_establishment" },
        { name: "Date of Signing", value: "date_of_signing" },
        { name: "Date of Entry", value: "date_of_entry" },
        { name: "Date of Exit", value: "date_of_exit" },
        { name: "Date of Distribution", value: "date_of_distribution" },
        { name: "Date of Reservation", value: "date_of_reservation" },
        { name: "Date of Feedback", value: "date_of_feedback" },
        { name: "Date of Update", value: "date_of_update" },
        { name: "Date of Launch", value: "date_of_launch" },
        { name: "Date of Withdrawal", value: "date_of_withdrawal" },
        { name: "Date of Refund", value: "date_of_refund" },
        { name: "Date of Notice", value: "date_of_notice" },
        { name: "Date of Resolution", value: "date_of_resolution" },
        { name: "Date of Resignation", value: "date_of_resignation" },
        { name: "Date of Reinstatement", value: "date_of_reinstatement" },
        { name: "Date of Engagement", value: "date_of_engagement" },
        { name: "Date of Contract", value: "date_of_contract" },
        { name: "Date of Fulfillment", value: "date_of_fulfillment" },
        { name: "Date of Acceptance", value: "date_of_acceptance" },
        { name: "Date of Lease", value: "date_of_lease" },
        { name: "Date of Construction", value: "date_of_construction" },
        { name: "Date of Agreement", value: "date_of_agreement" },
        { name: "Date of Request", value: "date_of_request" },
        { name: "Date of Processing", value: "date_of_processing" },
        { name: "Date of Upgrade", value: "date_of_upgrade" },
        { name: "Date of Installation", value: "date_of_installation" },
        { name: "Date of Expiration", value: "date_of_expiration" },
    ];

    return (
        <div className="formManagement">
            <ToastContainer
                autoClose={1000}
            />
            <div className="card">
                {
                    loadingState ? <Loding /> : null
                }

                <div className="row">
                    <div className="col-md-4">
                        <div className="formGroup">
                            <label>Parent Category *</label>
                            <select value={getSubCategory}
                                className="empty-field"
                                required
                                onChange={(val) => { setgetSubCategory(val.target.value) }}>
                                <option disabled>Select Category</option>
                                {
                                    getCategory?.map((item, i) => {
                                        return <option key={i} value={item.id}>{item.name}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="formGroup ">
                            <label>Select Sub Category *</label>
                            <select value={subCat}
                                required
                                onChange={(val) => { setSubcatory(val.target.value) }}
                            // className="empty-field"
                            >
                                <option>Choose Sub Category</option>
                                {
                                    selectSub?.map((item, i) => {
                                        return <option key={i} value={item?.id}>{item?.name}</option>
                                    })
                                }
                            </select>
                        </div>
                    </div>
                </div>
                <form onSubmit={addFld} id="resetForm">
                    <div className="row">
                        <div className="col-md-12">
                            <h2>Form Creation </h2>
                        </div>

                        <div className="col-md-3">
                            <div className="formGroup">
                                <label>Select Input Type *</label>

                                <select
                                    onChange={(val) => { setfldType(val.target.value) }}

                                // className={(isrequired || chooseFldType == null) ? 'required' :'' }

                                >
                                    <option>Select </option>
                                    <option value="text">Text Box</option>
                                    <option value="select">Select Box</option>
                                    <option value="textarea">Textarea</option>
                                    <option value="date">Date</option>
                                    {/* <option value="dob">DOB</option> */}
                                    <option value="time">Time</option>
                                    <option value="file">File</option>
                                </select>
                            </div>
                        </div>
                        {optionList?.length > 0 ?
                            <div className="col-md-3">
                                <div className="formGroup">
                                    <label>Choose Type *</label>
                                    <select
                                        //   className='required'
                                        value={choosetype} onChange={(val) => { setchoosetype(val.target.value) }}>
                                        <option selected value={0}>Choose Select Box</option>
                                        {
                                            optionList?.map((item, i) => {
                                                return <option
                                                    // onSelect={(item) => console.log(item)}
                                                    value={item.id} key={i}>{item.name}</option>
                                            })
                                        }

                                    </select>
                                </div>
                            </div> : ""
                        }
                        {
                            optionList?.length > 0 && (
                                <>
                                    <div className="col-md-1">
                                        <div className="formGroup-check">
                                            <label>Multiple</label>
                                            <div>
                                                <input
                                                    type='checkbox'
                                                    value={ismultiple}
                                                    checked={ismultiple == 1}
                                                    onChange={() => {
                                                        setismultiple(ismultiple == 0 ? 1 : 0

                                                        )
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </>
                            )
                        }
                        {
                            // chooseFldType !== 'date' && chooseFldType !== 'time' && chooseFldType !== 'fiile' ?

                            <div className="col-md-3">
                                <div className="formGroup">
                                    <label>Choose Label *</label>
                                    {
                                        (chooseFldType === 'select'

                                            || chooseFldType === 'file'
                                            || chooseFldType === 'time'
                                            // || chooseFldType ==='dob'
                                        )
                                            ?
                                            <div>
                                                <select
                                                    disabled={chooseFldType == 'select' ? true : false}
                                                    value={lebelnmaedata?.name}
                                                >
                                                    {/* <option value={0} key={0}>Label Name</option> */}

                                                    <option value={0} key={0}>{lebelnmaedata?.name}</option>
                                                </select>
                                            </div>
                                            :



                                            chooseFldType == 'date' ?
                                                <select value={labelvalue}
                                                    disabled={chooseFldType === '' ? true : false}
                                                    onChange={(val) => { setLabel(val.target.value) }}
                                                >



                                                    <option selected value={0}>Choose Date Label</option>
                                                    {
                                                        dateOptions?.map((item, i) => {
                                                            return <option value={item.value} key={i}>{item.name}</option>
                                                        })
                                                    }


                                                </select>
                                                :
                                                <select value={labelvalue}
                                                    disabled={chooseFldType === '' ? true : false}
                                                    onChange={(val) => { setLabel(val.target.value) }}
                                                >



                                                    <option selected value={0}>Choose Label</option>
                                                    {
                                                        labelList?.map((item, i) => {
                                                            return <option value={item.id} key={i}>{item.name}</option>
                                                        })
                                                    }


                                                </select>
                                    }
                                </div>
                            </div>
                            // : null
                        }
                        <div className="col-md-3">
                            <div className="formGroup">
                                <label>Field Name</label>
                                <input type="text"
                                    disabled={true}
                                    value={lebelnmaedata?.name}
                                    placeholder="Field Value" />
                            </div>
                        </div>

                        <div className="col-md-3">
                            <div className="formGroup">
                                <label>Placeholder *</label>
                                <input type="text" value={chooseplaceholder} placeholder="Enter Placeholder Name"
                                    onChange={(val) => { setChooseplaceholder(val.target.value) }}

                                />
                            </div>
                        </div>
                        <div className="col-md-3">
                            <div className="formGroup">
                                <label>Required *</label>
                                <select
                                    //   className='required'
                                    value={chooseRequired} onChange={(val) => { setChooseRequired(val.target.value) }}>
                                    {/* <option  value={0}>Select Required Type</option>
                                <option value={1}>Yes</option>
                                <option value={0}>No</option> */}
                                    {/* <option>Select Required Type</option> */}
                                    <option value={1}>Mandatory</option>
                                    <option value={0}>Optional</option>
                                </select>
                            </div>
                        </div>
                        <div className="col-md-4">
                            <div className="formGroup">
                                <label>&nbsp;</label>
                                <button
                                    disabled={
                                        (
                                            ((subCat == null || getSubCategory == null ||
                                                chooseplaceholder === '' || chooseFldType === '') || (choosetype == null && labelvalue == null))
                                            // choosetype == null
                                            // lebelnmaedata == null
                                            // lebelnmaedata == null

                                        )
                                            ? true : false
                                    }
                                    type="submit" className="addBtn">Add</button>
                            </div>

                        </div>
                    </div>
                </form>
                <form>
                    <div className="row" id="addDynamicFrm">
                        {
                            dynamicFld?.map((item, index) => {
                                if (item.type === "text") {

                                    // console.log("ok")
                                    return <div className="col-md-4" key={index}>
                                        <div className="formGroup">
                                            <label className="name-width">{item.label}</label>
                                            <div className="item-list">
                                                <input type={item.type} placeholder={item.place_holder} name={item.name} />
                                                <div className="cross-icon" onClick={() => ondeleteItems(index)}>
                                                    <div className="">
                                                        <p className="icon">X</p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                if (item.type == "select") {
                                    return <div className="col-md-4" key={index}>
                                        <div className="formGroup">
                                            <label>{item.label}  {item?.ismultiple == 1 ? '(Multiple)' : null}</label>
                                            <div className="item-list">
                                                <select>
                                                    <option selected>{item.place_holder}</option>
                                                    {/* <option></option> */}
                                                </select>
                                                <div className="cross-icon" onClick={() => ondeleteItems(index)}>
                                                    <div className="">
                                                        <p className="icon">X</p>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>


                                }
                                if (item.type == "textarea") {
                                    return <div className="col-md-4" key={index}>
                                        <div className="formGroup">
                                            <label>{item.label}</label>
                                            <div className="item-list">
                                                <textarea name={item.name} placeholder={item.place_holder}></textarea>
                                                <div className="cross-icon" onClick={() => ondeleteItems(index)}>
                                                    <div className="">
                                                        <p className="icon">X</p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                if (item.type == "date") {
                                    return <div className="col-md-4" key={index}>
                                        <div className="formGroup">
                                            <label>{item.label}</label>
                                            <div className="item-list">
                                                <input type={item.type} placeholder={item.place_holder} name={item.name} />
                                                <div className="cross-icon" onClick={() => ondeleteItems(index)}>
                                                    <div className="">
                                                        <p className="icon">X</p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                // if (item.type == "dob") {
                                //     return <div className="col-md-4" key={index}>
                                //         <div className="formGroup">
                                //             <label>{item.label}</label>
                                //             <div className="item-list">
                                //                 <input type='date' placeholder={item.place_holder} name={item.name} />
                                //                 <div className="cross-icon" onClick={() => ondeleteItems(index)}>
                                //                     <div className="">
                                //                         <p className="icon">X</p>

                                //                     </div>
                                //                 </div>
                                //             </div>
                                //         </div>
                                //     </div>
                                // }
                                if (item.type == "time") {
                                    return <div className="col-md-4" key={index}>
                                        <div className="formGroup">
                                            <label>{item.label}</label>
                                            <div className="item-list">
                                                <input type={item.type} placeholder={item.place_holder} name={item.name} />
                                                <div className="cross-icon" onClick={() => ondeleteItems(index)}>
                                                    <div className="">
                                                        <p className="icon">X</p>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                                if (item.type == "file") {
                                    return <div className="col-md-4" key={index}>
                                        <div className="formGroup">
                                            <label>{item.label}</label>
                                            <div className="item-list">
                                                <input type={item.type} name={item.name} />
                                                <div className="cross-icon" onClick={() => ondeleteItems(index)}>
                                                    <div className="">
                                                        <p className="icon">X</p>

                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                    </div>
                                }

                            })

                        }
                    </div>

                </form>
                <div className="row">
                    <div className="col-md-12">
                        <div className="btngrp">
                            <button type="button"
                                disabled={dynamicFld?.length != 0 ? false : true}

                                style={{ marginLeft: "0px" }} className="addBtn" onClick={FrmCreation}>{id != undefined ? 'Update' : 'Save'}</button>
                            <button type="button" className="addBtn " onClick={back}>Cancel</button>
                        </div>
                    </div>

                </div>

            </div>

        </div>
    )
}
export default FormManagement;


